import { render, staticRenderFns } from "./BottomSheetMailboxesSelection.vue?vue&type=template&id=12e9a3c2&scoped=true&"
import script from "./BottomSheetMailboxesSelection.vue?vue&type=script&lang=js&"
export * from "./BottomSheetMailboxesSelection.vue?vue&type=script&lang=js&"
import style0 from "./BottomSheetMailboxesSelection.vue?vue&type=style&index=0&id=12e9a3c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e9a3c2",
  null
  
)

export default component.exports